// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"260":"ddccf84f","519":"cb5858ab","708":"855806fd"}[chunkId] + ".css";
};